import _config from '@exp/exp-utils/helper/config';

_config.merge({
  'tcc.listenerDisabled': false,
  'tcc.manualPagePerf': false,
  'tcc.loadTTI': true,

  'tcc.eventDelayMs': 75,
  'tcc.perfDelayMs': 250,
  'tcc.consentDelayMs': 500,

  'tcc.gaAccountDev': 'UA-52262008-15',
  'tcc.gaAccountTest': 'UA-37178807-21',
  'tcc.gaAccountProd': 'UA-115508484-1',

  'tcc.buildEnv': 'production',
  'tcc.buildName': '@tcc/tcc',
  'tcc.buildVersion': '3.7.32',
  'tcc.buildDate': '2020-06-17T23:02:07.824Z',
  'tcc.splitioUrl': 'https://img1.wsimg.com/wrhs/153b0ee5f69840fe239a01574097118b/splitio.min.js',
  'tcc.splitioApiKey': '26b1lpi1u5ifu0ug7hj9t68j43qi0b1sulf6',
  'tcc.ttiUrl': 'https://img1.wsimg.com/wrhs/ee768b37adbe1f761458e24514bec4b1/tti.min.js'
});

export default _config;
